import { initializeApp } from "firebase/app";
import {
  enableIndexedDbPersistence,
  enableMultiTabIndexedDbPersistence,
  getFirestore,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);

const initPersistence = async () => {
  if (typeof window === "undefined" || !("indexedDB" in window)) {
    return false;
  }

  try {
    await enableMultiTabIndexedDbPersistence(db);

    return true;
  } catch (err) {
    if (err?.code === "unimplemented") {
      try {
        await enableIndexedDbPersistence(db);

        return true;
      } catch (_fallbackErr) {
        return false;
      }
    }

    return false;
  }
};

const persistenceReady = initPersistence();

export default { db, auth, persistenceReady };
